import { Box } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid-pro';
import { SilobagRow } from '@siloreal:modules:private/silobag-list/config/extra/types';
import {
  CalendarIconBadge,
  FALLBACK_STRING,
  FieldCellStack,
  FieldPrimaryText,
  MetaRow,
} from './column-field-ui';
import * as HOOKS from '@siloreal:shared:hooks';

export function buildBaggingDateColumn(): GridColDef<SilobagRow> {
  return {
    field: 'bagging_date',
    headerName: HOOKS.useLocale.getState().t('temp.common.bagging'),
    minWidth: 156,
    renderCell: (params) => (
      <BaggingDateCell
        baggingDate={params.row.bagging_date}
        harvestName={params.row.silobag_harvests?.name}
      />
    ),
  };
}

function BaggingDateCell({
  baggingDate,
  harvestName,
}: {
  baggingDate: string | null;
  harvestName?: string | null;
}) {
  const hasBaggingDate = Boolean(baggingDate);
  const hasHarvest = Boolean(harvestName?.trim());
  const harvestLabel = harvestName?.trim() || FALLBACK_STRING;
  const i18n = HOOKS.useLocale();

  return (
    <FieldCellStack>
      <CalendarIconBadge active={hasBaggingDate} />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <FieldPrimaryText
          title={
            hasBaggingDate ? formatBaggingMonth(baggingDate) : i18n.t('temp.common.bagging_date_unavailable')
          }
          disabled={!hasBaggingDate}
        >
          {formatBaggingMonth(baggingDate)}
        </FieldPrimaryText>

        <MetaRow
          tag="COS."
          disabled={!hasHarvest}
          valueTitle={hasHarvest ? harvestLabel : i18n.t('temp.common.harvest_unavailable')}
        >
          {harvestLabel}
        </MetaRow>
      </Box>
    </FieldCellStack>
  );
}

function formatBaggingMonth(value: string | null): string {
  if (!value) return FALLBACK_STRING;

  const formatted = new Intl.DateTimeFormat('es-AR', { month: 'short', year: 'numeric' }).format(
    new Date(value)
  );

  return formatted.charAt(0).toUpperCase() + formatted.slice(1).replace('.', '');
}
